const getTradingItemLEPFlag = (product: ProductFragment.LEPFlags, tradingItem: TradingItemFragment.LEPFlags) => {
  return product.hasLep ? tradingItem?.isLimitedEdition : product?.isProductHasLimitedEdition
}

export default getTradingItemLEPFlag
